import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(this.hasToken());
  public isAuthenticated$: Observable<boolean> = this.isAuthenticatedSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private router: Router
  ) {}

  private hasToken(): boolean {
    return !!localStorage.getItem('admin_token');
  }

  login(login: string, password: string): Observable<any> {
    return this.apiService.adminLogin(login, password).pipe(
      tap(response => {
        localStorage.setItem('admin_token', response.token);
        localStorage.setItem('token_expire', response.expire);
        this.isAuthenticatedSubject.next(true);
      })
    );
  }

  logout(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('token_expire');
    this.isAuthenticatedSubject.next(false);
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('admin_token');
    const expire = localStorage.getItem('token_expire');
    
    if (!token || !expire) {
      return false;
    }

    const expireDate = new Date(expire);
    const now = new Date();
    
    if (now > expireDate) {
      this.logout();
      return false;
    }

    return true;
  }
}
